<svg viewBox="10 10 320 320" role="img" aria-label="Dual rotating ring animation">
	<defs>
		<g id="rings" class="rings">
			<ellipse
				cx="170"
				cy="170"
				rx="118.3500"
				ry="118.5800"
				opacity="1.0000"
				transform="rotate(0.00 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="114.2175"
				ry="120.1213"
				opacity="0.9583"
				transform="rotate(-4.12 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="110.0850"
				ry="121.6625"
				opacity="0.9167"
				transform="rotate(-8.24 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="105.9525"
				ry="123.2037"
				opacity="0.8750"
				transform="rotate(-12.36 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="101.8200"
				ry="124.7450"
				opacity="0.8333"
				transform="rotate(-16.48 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="97.6875"
				ry="126.2862"
				opacity="0.7917"
				transform="rotate(-20.60 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="93.5550"
				ry="127.8275"
				opacity="0.7500"
				transform="rotate(-24.72 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="89.4225"
				ry="129.3688"
				opacity="0.7083"
				transform="rotate(-28.84 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="85.2900"
				ry="130.9100"
				opacity="0.6667"
				transform="rotate(-32.96 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="81.1575"
				ry="132.4512"
				opacity="0.6250"
				transform="rotate(-37.08 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="77.0250"
				ry="133.9925"
				opacity="0.5833"
				transform="rotate(-41.20 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="72.8925"
				ry="135.5337"
				opacity="0.5417"
				transform="rotate(-45.32 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="68.7600"
				ry="137.0750"
				opacity="0.5000"
				transform="rotate(-49.44 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="64.6275"
				ry="138.6162"
				opacity="0.4583"
				transform="rotate(-53.56 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="60.4950"
				ry="140.1575"
				opacity="0.4167"
				transform="rotate(-57.68 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="56.3625"
				ry="141.6987"
				opacity="0.3750"
				transform="rotate(-61.80 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="52.2300"
				ry="143.2400"
				opacity="0.3333"
				transform="rotate(-65.92 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="48.0975"
				ry="144.7813"
				opacity="0.2917"
				transform="rotate(-70.04 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="43.9650"
				ry="146.3225"
				opacity="0.2500"
				transform="rotate(-74.16 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="39.8325"
				ry="147.8637"
				opacity="0.2083"
				transform="rotate(-78.28 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="35.7000"
				ry="149.4050"
				opacity="0.1667"
				transform="rotate(-82.40 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="31.5675"
				ry="150.9462"
				opacity="0.1250"
				transform="rotate(-86.52 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="27.4350"
				ry="152.4875"
				opacity="0.0833"
				transform="rotate(-90.64 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="23.3025"
				ry="154.0288"
				opacity="0.0417"
				transform="rotate(-94.76 170 170)"
			/>
			<ellipse
				cx="170"
				cy="170"
				rx="19.1700"
				ry="155.5700"
				opacity="0.0000"
				transform="rotate(-98.88 170 170)"
			/>
		</g>
	</defs>

	<g class="g1">
		<g class="spin spin1">
			<use href="#rings" />
		</g>
	</g>

	<g class="g2 move2">
		<g class="spin spin2">
			<use href="#rings" />
		</g>
	</g>
</svg>

<style>
	:root {
		--bg: #000;
		--ring: #2491ff;
		--dur: 8s; /* 480 frames @ 60fps */
	}

	svg {
		display: block;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

	.rings {
		fill: none;
		stroke: var(--ring);
		stroke-width: 1;
		vector-effect: non-scaling-stroke;
	}

	.spin {
		transform-origin: 170px 170px;
		transform-box: view-box;
	}

	.g1 {
		opacity: 0.85;
	}

	.g2 {
		opacity: 0.7;
	}

	.spin1 {
		animation: spin1 var(--dur) linear infinite;
	}

	.spin2 {
		animation: spin2 var(--dur) linear infinite;
	}

	.move2 {
		animation: move2 var(--dur) infinite;
	}

	@keyframes spin1 {
		from {
			transform: rotate(90.41deg);
		}
		to {
			transform: rotate(-269.59deg);
		} /* clockwise one full turn */
	}

	@keyframes spin2 {
		from {
			transform: rotate(-90.41deg);
		}
		to {
			transform: rotate(269.59deg);
		} /* counterclockwise one full turn */
	}

	/* keyframes at 0/120/240/360/480 with smoothstep easing per segment */
	@keyframes move2 {
		0% {
			transform: translate(0px, 0px);
			animation-timing-function: cubic-bezier(0.333333, 0, 0.666667, 1);
		}
		25% {
			transform: translate(9px, 11px);
			animation-timing-function: cubic-bezier(0.333333, 0, 0.666667, 1);
		}
		50% {
			transform: translate(9px, 8px);
			animation-timing-function: cubic-bezier(0.333333, 0, 0.666667, 1);
		}
		75% {
			transform: translate(0px, 2px);
			animation-timing-function: cubic-bezier(0.333333, 0, 0.666667, 1);
		}
		100% {
			transform: translate(0px, 0px);
		}
	}
</style>
